import { useState } from 'react';
import { Form, Input, Button, Row, Col, message } from 'antd';
import { api } from '../api';

export default function AddressForm({ address, onSaved }) {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const handleSave = async (values) => {
    setSaving(true);
    try {
      await api.addresses.update(address.id, values);
      message.success('Adresse gespeichert');
      onSaved?.();
    } catch (err) {
      message.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form form={form} layout="vertical" initialValues={address} onFinish={handleSave}>
      <Row gutter={12}>
        <Col span={16}>
          <Form.Item name="street" label="Straße" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="nr" label="Nr." rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item name="postal_code" label="PLZ">
            <Input />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item name="city" label="Ort">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="country" label="Land">
            <Input maxLength={3} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="doorbell" label="Klingel">
        <Input />
      </Form.Item>
      <Form.Item name="remarks" label="Hinweise">
        <Input.TextArea rows={2} />
      </Form.Item>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item name="geo_lat" label="Geo-Lat">
            <Input type="number" step="any" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="geo_lon" label="Geo-Lon">
            <Input type="number" step="any" />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item style={{ marginBottom: 0 }}>
        <Button type="primary" htmlType="submit" loading={saving}>Speichern</Button>
      </Form.Item>
    </Form>
  );
}
